import { withTranslation } from 'react-i18next';
import React from "react";

class OtpPopup extends React.PureComponent {

    constructor(props) {
        super(props);
        this.state = {
            otp: ""
        }
    }
    render() {
        return (
            <div>
                <div className='custom-popup custom-scrollable' style={{ height: "200px", width: "300px" }}>
                    <div className='custom-popup-header pt-2'>
                        <div  style={{ fontSize: "14px" }}>Enter OTP</div>
                        <div  className="mr-3" style={{ marginLeft: "auto" }}>
                            <span
                                className="my-panel-extra-btn"
                                style={{
                                    marginLeft: "auto",
                                    float: "right",
                                    transition: "none",
                                    color: "white",
                                    opacity: "1",
                                    contain: "content",
                                    width: "unset",
                                    marginRight: "unset"
                                }}
                                onClick={(e) => {
                                    this.props.onClose(e);
                                }}>X</span>
                        </div>
                    </div>
                    <div
                        className="custom-popup-body pt-2 pb-2 pl-2 pr-2 display-vertically center"
                        style={{ height: "calc(100% - 45px)", overflowY: "auto", width: "80%" }} >
                        <input
                            className="input-textbox mb-2"
                            style={{ marginTop: "auto" }}
                            type="password"
                            name="otp"
                            autocomplete="off"
                            placeholder={this.props.t("otp")}
                            value={this.props.otp}
                            onChange={(e) => {
                                e.preventDefault();
                                this.setState({ otp: e.target.value });
                            }}
                        />
                        <div style={{ display: "flex", marginBottom: "auto" }}>
                            <button
                                className="btn custom-btn-primary mr-2 ml-2"
                                style={{ contain: "content", backgroundColor: "#165B81", width: "98px" }}
                                onClick={() => {
                                    this.props.callRegistrationsOTP(this.props.onClose, this.state.otp);
                                }}
                            >
                                Submit OTP
                            </button>

                            <button
                                className="btn custom-btn-cancel mr-2 ml-2"
                                style={{ width: "60px" }}
                                onClick={(e) => this.props.onClose(e)}>{this.props.t("cancel")}</button>
                        </div>

                    </div>
                </div >

            </div>
        )
    }
}

export default withTranslation()(OtpPopup)